// langSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LangType = {selected: "EN" | "RU" | "CN"}

const initialState: LangType = {selected: "RU"};

// Create a slice
const langSlice = createSlice({
    name: 'lang',
    initialState,
    reducers: {
        setCurrentLang: (state, action: PayloadAction<LangType>) => {
            state.selected = action.payload.selected;
        },
    },
});

// Export the actions and reducer
export const { setCurrentLang } = langSlice.actions;
export default langSlice.reducer;

